/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SkinsbackWebhookRequest = {
    /**
     * Skinsback transaction ID
     */
    transaction_id: string;
    /**
     * Deposit status
     */
    status: SkinsbackWebhookRequest.status;
    /**
     * Our internal order ID
     */
    order_id: string;
    /**
     * HMAC-SHA1 signature for verification
     */
    sign: string;
    /**
     * Steam user ID (optional)
     */
    steam_id?: string;
    /**
     * Deposit amount in USD (optional)
     */
    amount?: number;
    /**
     * User deposit amount in USD (optional)
     */
    user_amount?: number;
    /**
     * Failure reason if status is fail (optional)
     */
    fail_reason?: SkinsbackWebhookRequest.fail_reason;
    /**
     * Steam trade offer ID (optional)
     */
    trade_offer_id?: string;
    /**
     * Legacy field - use amount instead (optional)
     */
    sum?: string;
    /**
     * Risk assessment: total deposit count (optional)
     */
    total_deposit_count?: number;
    /**
     * Risk assessment: total deposit sum (optional)
     */
    total_deposit_sum?: number;
};
export namespace SkinsbackWebhookRequest {
    /**
     * Deposit status
     */
    export enum status {
        PENDING = 'pending',
        IN_HOLD = 'in_hold',
        SUCCESS = 'success',
        FAIL = 'fail',
        HOLD_APPROVED = 'hold_approved',
        HOLD_RETURNED = 'hold_returned',
    }
    /**
     * Failure reason if status is fail (optional)
     */
    export enum fail_reason {
        TIMEOUT = 'timeout',
        TRADE_TIMEOUT = 'trade_timeout',
        TRADE_CANCELED = 'trade_canceled',
    }
}

